const WEBSITE_NAME = "Analytics";

export default {
  WEBSITE_NAME: WEBSITE_NAME
};
